import { Link } from "react-router-dom";
import styled from "styled-components";

const ClaimButtonNFTStyle = styled(Link) <{ $isErc721?: boolean }>`
  display: flex;
  position: relative;
  overflow: hidden;
  flex-flow: column;
  align-items: center;
  gap: 4px;
  padding: 8px;
  width: 100%;
  
  color: ${({ theme }) => theme?.colors?.theme?.button};
  font-weight: 600;
  font-size: 16px;
  margin: 0 auto;
  
  text-align: center;
  background: ${({ $isErc721, theme }) =>  $isErc721 ? "rgba(255,255,255,0.5)" : theme?.colors?.text?.muted};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  
  span {
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: 50ms;
    z-index: 200;
  }
  
  &:hover {
    span {
      color: inherit;
    }
  }
`;

export {
  ClaimButtonNFTStyle
}

